<script>
  import InfoCard from "@sourcewhale/shared/svelte-design-system/components/molecules/Cards/InfoCard.svelte";
  import { todosModalItemStore } from "../stores";

  const OPPORTUNITY_KINDS = {
    missedConnection: {
      icon: "fas fa-calendar-users",
      title: "Missed Connection",
    },
    followUpReminder: {
      icon: "fas fa-alarm-clock",
      title: "Follow-up Reminder",
    },
    careerMove: {
      icon: "fas fa-arrow-right-arrow-left",
      title: "Career Move",
    },
    silentInterest: {
      icon: "fas fa-fire",
      title: "Hotlist",
    },
  };
</script>

{#if Object.keys($todosModalItemStore || {}).length && $todosModalItemStore.kind === "opportunity"}
  {@const { opportunityKind, opportunityDescription } = $todosModalItemStore}
  {@const { icon, title } = OPPORTUNITY_KINDS[opportunityKind]}
  <InfoCard
    {icon}
    header={title}
    style="margin-top: 1.875rem; margin-bottom: 1.25rem;"
  >
    {opportunityDescription.full}
  </InfoCard>
{/if}
